import { registerQuery, useQuery } from 'data-fetching-client';
import { HubsSettingClient } from 'frontend-preferences-client';
const hubsSettingsClient = HubsSettingClient.forCaller('payments-enrollment-embed-lib');
const HUBS_SETTINGS_QUERY = registerQuery({
  fieldName: 'hubsSetting',
  args: ['key', 'defaultValue'],
  fetcher: ({
    key,
    defaultValue
  }) => {
    return hubsSettingsClient.fetch(key, defaultValue);
  }
});
export const useHasSeenUseCasesModal = () => {
  const {
    data,
    loading,
    error
  } = useQuery(HUBS_SETTINGS_QUERY, {
    variables: {
      key: 'CommerceGrowth:CommerceOverview:HasSeenUseCasesModal',
      defaultValue: 'false'
    }
  });
  return {
    hasSeenUseCasesModal: (data === null || data === void 0 ? void 0 : data.hubsSetting) === 'true',
    isHasSeenUseCasesModalLoading: loading,
    isHasSeenUseCasesModalError: error
  };
};